import { isEmpty } from '../../../utils'

export const dropDownProps = {
  value: {
    type: String,
    default: '',
    require: true
  },
  // 下拉未选择时的默认文案
  placeholder: {
    type: String,
    default: '请选择'
  },
  // 是否进搜索
  searchable: {
    type: Boolean,
    default: false,
    require: false
  },
  // apiName
  apiName: {
    type: String,
    default: '',
    require: true
  },
  // title
  name: {
    type: String,
    default: ''
  },
  isPureText: {
    type: Boolean,
    default: true
  },
  disabled: {
    type: Boolean,
    default: false
  },
  size: {
    type: String,
    default: 'small'
  }
}

export function initValue (value) {
  return isEmpty(value) ? '-' : value
}
